import { Component, OnDestroy, ViewChild } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatSidenav, MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { PAGES, PAGE } from '@constants/constants';
import { ICONS } from '@constants/icons';
import { COLORS } from '@constants/colors';
import { URLS } from '@constants/urls';
import { HeaderComponent } from '@layout/header.component';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { AbbCommonModule } from 'app/abb-common.module';
import { filter, Subscription } from 'rxjs';
import { TPipe } from '@pipes/t.pipe';
import { PermissionsService } from '@services/user/permissions.service';

@Component({
  selector: 'abb-home',
  standalone: true,
  imports: [
    TPipe,
    CommonModule,
    RouterModule,
    MatDividerModule,
    MatSidenavModule,
    MatListModule,
    HeaderComponent,
    AbbCommonModule,
  ],
  templateUrl: './home.component.html',
  styles: ``,
  host: {
    class: 'flex flex-col h-full w-full',
  },
})
export class HomeComponent implements OnDestroy {
  @ViewChild(MatSidenav) sidenav!: MatSidenav;
  readonly PAGES: Array<PAGE> = Object.values(PAGES);
  readonly ICONS: ICONS = ICONS;
  readonly COLORS: COLORS = COLORS;
  readonly URLS: URLS = URLS;
  isCollapsed: boolean = false;
  activeRoute: string | undefined;

  subscriptions: Subscription[] = [];
  constructor(
    private router: Router,
    private permissionsService: PermissionsService
  ) {
    this.subscriptions.push(
      this.router.events
        .pipe(filter((event) => event instanceof NavigationEnd))
        .subscribe({
          next: (event: any) => {
            this.activeRoute = (event as NavigationEnd).urlAfterRedirects;
          },
          error: (err) => {
            console.error('Navigation event error: ', err);
          },
        })
    );
  }

  authorized(page: PAGE) {
    const url = Object.keys(URLS).find(
      (key) => URLS[key as keyof URLS] === page.link?.split('/').at(1)
    ) as keyof URLS;
    return this.permissionsService.canView(url);
  }

  toggleMenu() {
    this.sidenav.open();
    this.isCollapsed = !this.isCollapsed;
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }
}
